<template>
  <Card title="setting.template_config" containerClass="mb-5">
    <template #cardBody>
      <div class="row">
        <div  
          class="col-md-6 col-12"
          v-for="(template, index) in templates"
          :key="index"
        >
          <ConfigForm
            :id="template.id" 
            :template="template"
            @submit="setDefault"
          ></ConfigForm>
        </div>
      </div>
    </template>
  </Card>
</template>

<script setup>
import Card from "@/Modules/CRM/components/Card.vue";
import { onMounted, computed} from 'vue'
import {useStore} from "vuex";
import ConfigForm from "./ConfigForm.vue";

const store = useStore()

const templates = computed(() => store.getters["configs/getTemplates"])

onMounted(() => {
  store.dispatch('configs/loadTemplateByModule')
})

function setDefault(data){
    store.dispatch('configs/setDefaultTemplate', data)
        .then((response) => {
          window.toastr['success'](i18n.global.t('notification.set_default_template'))
        })
        .catch(err => {
        })
}
</script>

